export enum ScheduleType {
  UPCOMING = 1,
  EXPIRED = 2,
}

export enum TestType {
  NORMAL = 1,
  EMERGENCY = 2,
}
